import { taskListTaskTypeDef } from "./task-list-task-type-def";

export const taskListTaskServiceTypeDef = `
  ${taskListTaskTypeDef}
  claimNumber
  dateOfLoss
  carVin
  carLicensePlate
  carYearManufactured
  carModel
`;
